// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-west-2",
    "aws_cognito_identity_pool_id": "us-west-2:d2459c7a-bd75-41bd-8c2b-06f8a0b59763",
    "aws_cognito_region": "us-west-2",
    "aws_user_pools_id": "us-west-2_4q3hucaif",
    "aws_user_pools_web_client_id": "3bfcam5dmfmq4qa7lipmra34bs",
    "oauth": {}
};


export default awsmobile;
